import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {getLocalStorageVariables,
    isEmptyVariable, isEmptyArray,
    handleTokenExpiry} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import RegularDropdown from '../../../common/DropdownMenus/RegularDropdown';
import {DialogSaveButton} from '../../../common/Global/globalStyles.style';
import AlertDialog from '../../../common/AlertDialog';

let userDetails = getLocalStorageVariables();

const departmentDropdownDefaultValue = "Select Department";

class AddProcessDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,

            processName:"",
            processShortName:"",
            selectedDepartmentName:departmentDropdownDefaultValue,
            selectedDepartmentId:"",
            formErrors:{},
            submitClickedAtleastOnce:false,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showCreateDialog){
            let selectedDepartmentId = "";
            let selectedDepartmentName = departmentDropdownDefaultValue;

            if(!isEmptyVariable(this.props.departmentArr) && 
            this.props.departmentArr.length===1){
                selectedDepartmentId = this.props.departmentArr[0].departmentId;
                selectedDepartmentName = this.props.departmentArr[0].name;
            }

            if(this.props.isEdit){
                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
    
                    processName:this.props.processName,
                    processShortName:isEmptyVariable(this.props.processShortName)?"":this.props.processShortName,
                    selectedDepartmentName:selectedDepartmentName, //NOT REQ
                    selectedDepartmentId:selectedDepartmentId,//NOT REQ
                    formErrors:{},
                    submitClickedAtleastOnce:false,
                })
            }else{
                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
    
                    processName:"",
                    processShortName:"",
                    selectedDepartmentName:selectedDepartmentName,
                    selectedDepartmentId:selectedDepartmentId,
                    formErrors:{},
                    submitClickedAtleastOnce:false,
                })
            }
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    deptDropdownClick = (item) => {
        let FormErrorsTemp  = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['deparment'] = "";
        }

        this.setState({
            selectedDepartmentName:item.name,
            selectedDepartmentId:item.departmentId,
            formErrors:FormErrorsTemp
        })
    }

    handleCreateDialogClose = () =>{
        this.props.handleAddEditDialogClose(false);
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    onEnterBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.handleCreateMaster();
        }
    }

    handleCreateMaster = () => {
        this.setState({
            showLoader:true,
            submitClickedAtleastOnce:true,
        });
        
        let isError = false;
        let FormErrorsTemp = {};

        if(isEmptyVariable(this.state.processName)){
            isError = true;
            FormErrorsTemp['processName'] = "Please enter process name";
        }

        //Dept check is not needed for edit since we are not showing the dept dropdown
        //and we are not passing the dept value as well
        if(!this.props.isEdit){
            if(isEmptyVariable(this.state.selectedDepartmentName) || 
            this.state.selectedDepartmentName === departmentDropdownDefaultValue){
                isError = true;
                FormErrorsTemp['deparment'] = "Please select department";
            }
        }

        if(isError){
            this.setState({
                formErrors:FormErrorsTemp,
                showLoader:false
            });

        }else{
            let url = "";
            let postParam = {
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            }

            if(this.props.isEdit){
                url = Constants.UpdateProcess;
                let processObj = {
                    processId:this.props.selectedId,
                    processName:this.state.processName,
                    processShortName:this.state.processShortName,
                }
                postParam.process = JSON.stringify(processObj);
                postParam.rootProcessId = this.props.rootProcessId;
            }else{
                postParam.departmentId = this.state.selectedDepartmentId;
                if(this.props.createNodeType === "root"){
                    url = Constants.AddRootProcess;
                    let processObj = {
                        processId:0,
                        processName:this.state.processName,
                        processShortName:this.state.processShortName,
                    }
                    postParam.process = JSON.stringify(processObj);

                }else if(this.props.createNodeType === "child"){
                    url = Constants.AddChildProcess;
                    let processObj = {
                        processId:0,
                        processName:this.state.processName,
                        processShortName:this.state.processShortName,
                    }

                    postParam.childProcess = JSON.stringify(processObj);
                    postParam.parentProcessId = this.props.relativeProcessId;
                    postParam.rootProcessId = this.props.rootProcessId;
                    
                }else if(this.props.createNodeType === "sibling"){
                    url = Constants.AddSiblingProcess;

                    let processObj = {
                        processId:0,
                        processName:this.state.processName,
                        processShortName:this.state.processShortName,
                    }

                    postParam.siblingProcess = JSON.stringify(processObj);
                    postParam.targetProcessId = this.props.relativeProcessId;
                    postParam.rootProcessId = this.props.rootProcessId;
                }
            }

            fetch(url,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams(postParam)
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    let createNodeTypeTemp = this.props.createNodeType;

                    if(createNodeTypeTemp === "root"){
                        this.setState({
                            showLoader:false,
                            processName:"",
                            processShortName:"",
                            formErrors:{},
                        },() => {
                            this.props.handleAddEditDialogClose(true);
                        });
                    }else if(createNodeTypeTemp === "child" ||
                    createNodeTypeTemp === "sibling"){
                        this.setState({
                            showLoader:false,
                            processName:"",
                            processShortName:"",
                            formErrors:{},
                        },() => {
                            this.props.handleAddEditDialogClose(true);
                        });
                    }
                }else{
                    this.setState({
                        showLoader:false,
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    });
                }
            });
        }
    }

    render() {
        return(
            <>
            <Modal className="custom-dialog" show={this.props.showCreateDialog} backdrop="static">
                <Modal.Header>
                    <h5>{this.props.isEdit?"Edit Process":"Add Process"}</h5>
                    <button 
                        onClick={this.handleCreateDialogClose}
                        type="button" data-dismiss="modal">
                        <span class="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div class="modal-body">
                    <div class="addnew-modal-form">
                        {
                            !this.props.isEdit &&
                            !isEmptyArray(this.props.departmentArr) &&
                            this.props.departmentArr.length > 1 &&
                            <div class="addnew-modal-form-group">
                                <p>Department*</p>
                                <RegularDropdown 
                                    placeholder={this.state.selectedDepartmentName}
                                    dropdownArr={this.props.departmentArr}
                                    labelParam="name"
                                    onDropDownItemClick={this.deptDropdownClick}
                                    isFocusRequired={true}
                                    defaultPlaceholderDropDown={departmentDropdownDefaultValue}
                                />
                                {
                                    !isEmptyVariable(this.state.formErrors['deparment']) &&
                                    <span class="cm-error">{this.state.formErrors['deparment']}</span>
                                }
                            </div>
                        }
                        <div class="addnew-modal-form-group">
                            <p>Process Short Name</p>
                            <input type="text" placeholder="Enter Process Short Name" onKeyPress={this.onEnterBtnPress} spellCheck="true" 
                            name="processShortName" value={this.state.processShortName} onChange={this.handleChange}/>
                        </div>
                        <div class="addnew-modal-form-group">
                            <p>Process Name*</p>
                            <input type="text" placeholder="Enter Process Name" onKeyPress={this.onEnterBtnPress} spellCheck="true" 
                            name="processName" value={this.state.processName} onChange={this.handleChange}/>
                            {
                                !isEmptyVariable(this.state.formErrors['processName']) &&
                                <span class="cm-error">{this.state.formErrors['processName']}</span>
                            }
                        </div>
                    </div>
                    <div class="modal-close-save">
                        <div class="close-save-col">
                            <button onClick={this.handleCreateDialogClose} type="button" class="modal-close">Cancel</button>
                            <DialogSaveButton 
                            themeSettings={this.props.themeSettings}
                            onClick={this.handleCreateMaster} type="button" class="modal-save">
                                {this.state.showLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                            </DialogSaveButton>
                        </div>
                    </div>
                </div>
            </Modal>
            <AlertDialog
                showAlertDialog={this.state.showAlertDialogInfo}
                handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                type={Constants.ALERT_TYPE_ALERT}
                alertDialogMessage={this.state.alertDialogMessageInfo}
                proceedBtnClick={this.handleAlertDialogCloseInfo}
                proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                themeSettings={this.props.themeSettings}
            />
            </>
        );
    }
}

export default AddProcessDialog;